class VwHbsHastaliktanimDTO {
    id: number = null;
    organizasyonId?: number = null;
    adi?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
}
export default VwHbsHastaliktanimDTO;